import React from 'react';

export const CreativeLayout = ({ slots, spacingMultiplier = 1.0 }) => {
  const { header, main, sidebar, footer } = slots;

  return (
    <div 
      className="resume-layout-creative"
      style={{
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        minHeight: '100%',
        boxSizing: 'border-box',
        gap: `calc(var(--spacing-element-gap, 20px) * ${spacingMultiplier})`,
        position: 'relative'
      }}
    >
      {/* Decorative Accent Bar on the Left Edge of the Page */}
      <div 
        className="resume-accent-bar" 
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: 'var(--layout-accent-bar-width, 6px)',
          backgroundColor: 'var(--color-accent, #3b82f6)'
        }}
      />

      {/* Header slot with left offset to prevent overlapping accent bar */}
      {header && (
        <header 
          className="resume-header-slot" 
          style={{ 
            gridColumn: '1 / -1',
            paddingLeft: 'var(--layout-accent-bar-width, 6px)'
          }}
        >
          {header}
        </header>
      )}

      {/* Core Split Body */}
      <div 
        className="resume-columns-body" 
        style={{
          display: 'grid',
          gridTemplateColumns: 'var(--layout-sidebar-width, 220px) 1fr',
          gap: `calc(var(--layout-column-gap, 24px) * ${spacingMultiplier})`,
          paddingLeft: 'var(--layout-accent-bar-width, 6px)'
        }}
      >
        <aside className="resume-sidebar-slot" style={{ borderRight: '1px solid var(--color-border, #e5e7eb)', paddingRight: '16px' }}>
          {sidebar}
        </aside>

        <main className="resume-main-slot">
          {main}
        </main>
      </div>

      {footer && (
        <footer 
          className="resume-footer-slot" 
          style={{ 
            gridColumn: '1 / -1',
            paddingLeft: 'var(--layout-accent-bar-width, 6px)'
          }}
        >
          {footer}
        </footer>
      )}
    </div>
  );
};
